<!--
/**
* @name: Add.vue
* @description: 新增/编辑物料扩展信息
* @author: 于海威
* @create: 2020/08/13 13:47:44
* @update: 2020/08/13 13:47:44
*/
-->

<template>
  <y-view :loading="isLoading">
    <div class="navigate-box"><span class="navigate-item">商品管理</span><span class="navigate-item">物料扩展信息</span></div>
    <div class="form-box">
      <y-form title="基本信息" id="basic" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-form-item title="物料编码:">{{ basePara.goodsCode }}</y-form-item>
        <y-form-item title="物料名称:">{{ basePara.goodsName }}</y-form-item>
        <y-form-item title="物料系列:">{{ basePara.goodsSeriesName }}</y-form-item>
        <y-form-item title="主数据分类:">{{ basePara.goodsTypeParentNames }}</y-form-item>
        <y-form-item title="品牌:">{{ basePara.goodsBrandName }}</y-form-item>
        <y-form-item title="品牌归属地:">{{ basePara.goodsBrandCountryName }}</y-form-item>
        <y-form-item title="基本计量单位:">{{ basePara.basicUnit }}</y-form-item>
        <y-form-item title="毛重:">{{ basePara.grossWeight }}KG</y-form-item>
        <y-form-item title="条码:">{{ basePara.barcode }}</y-form-item>
        <y-form-item required title="商城分类:">
          <k-select2
            :class="css.inputW"
            :data="goodsCatList"
            text-field="parentNameUrl"
            search-field="parentNameUrl"
            key-field="pidUrl"
            style="width: 300px;"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择商品分类"
            v-model="goodsTypeIdList"
          >
          </k-select2>
        </y-form-item>
        <y-form-item title="中文说明书:" align="top">
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
            <y-image @delete="onDelete1" v-dragging="{ list: chineseManualList, item: img, group: 'image' }" v-for="(img, index) in chineseManualList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 3M，建议尺寸750*750 px）</div>
        </y-form-item>
        <y-form-item title="关键词:" align="top">
          <k-input tag="textarea" v-model="keywordList" clearable block placeholder="请用英文逗号隔开的分割字符"></k-input>
        </y-form-item>
      </y-form>
      <div class="spliter"></div>
      <y-form title="商品图片:" id="picture" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="100%">
        <y-form-item title="图片:" align="top" required>
          <div class="row">
            <y-upload-file fileType="image" multiple :uploadUrl="uploadUrl" @uploaded="onUploadedImg"></y-upload-file>
            <y-image @delete="onDelete2" v-dragging="{ list: imgList, item: img, group: 'image' }" v-for="(img, index) in imgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">用于商品列表页的展示，建议尺寸750*750 px，最少上传1张，最多上传6张，每张大小不超过3M。</div>
        </y-form-item>
      </y-form>
      <div class="spliter"></div>
      <y-form title="商品描述" id="description" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="825px">
        <y-form-item title="描述信息:" align="top" required>
          <ueditor v-model="editPara.describeContent"></ueditor>
        </y-form-item>
      </y-form>
      <div class="spliter"></div>
      <y-form title="属性" id="attribute" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-form-item :title="item.name" v-for="(item, index) in attrList" :key="index">
          <div>
            <k-radio v-for="(list, vo) in item.goodsAttributeDetailVOList" :key="vo" v-model="selectId[index]" :value="list.id">{{ list.value }}</k-radio>
          </div>
        </y-form-item>
      </y-form>
    </div>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
    <y-anchor :anchor="anchorList"></y-anchor>
  </y-view>
</template>

<script>
import {
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_BASE_DATA_DETAIL,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DETAIL,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SAVE,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_UPDATE,
  NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST_BY_GOODSTYPEIDS,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  goodsCode: "",
  id: "",
  describeContent: "",
  keywordList: [],
  goodsTypeIdList: [],
  attributeDetailIdList: [],
  goodsMaterialExtendPictureList: [],
  chineseManual: "",
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      keywordList: "",
      selectId: [],
      basePara: {},
      isSaving: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      isView: false,
      isEdit: false,
      originData: {},
      goodsCatList: [],
      goodsTypeIdList: [],
      attrList: [],
      imgList: [],
      chineseManualList: [],
      anchorList: [
        {
          id: "basic",
          text: "基本信息",
        },
        {
          id: "picture",
          text: "商品图片",
        },
        {
          id: "description",
          text: "商品描述",
        },
        {
          id: "attribute",
          text: "属性",
        },
      ],
    };
  },
  watch: {
    goodsTypeIdList(nValue, oValue) {
      this.getAttrList();
    },
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        if (this.goodsTypeIdList.length === 0 || this.imgList.length === 0 || !para.describeContent) {
          status = true;
        }
      }
      return status;
    },
  },
  methods: {
    onUploaded(data) {
      this.chineseManualList = [];
      this.chineseManualList.push(data.data[0].url);
    },
    onUploadedImg(data) {
      for (let i = 0; i < data.data.length; i++) {
        this.imgList.push(data.data[i].url);
      }
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "materielList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      let goodsImgList = [];
      let goodsTypeIdList = [];
      let attributeDetailIdList = [];
      this.imgList.forEach((item, index) => {
        goodsImgList.push({ url: item, sort: index });
      });
      for (let i = 0; i < this.goodsTypeIdList.length; i++) {
        goodsTypeIdList.push(this.goodsTypeIdList[i].split("-")[2]);
      }
      for (let i = 0; i < this.selectId.length; i++) {
        attributeDetailIdList.push(this.selectId[i]);
      }
      para.goodsMaterialExtendPictureList = goodsImgList;
      para.chineseManual = this.chineseManualList.join(",");
      para.keywordList = this.keywordList.split(",");
      para.goodsTypeIdList = goodsTypeIdList;
      para.attributeDetailIdList = attributeDetailIdList;
      this.isSaving = true;
      this.$fetch({
        api: this.isEdit ? NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_UPDATE : NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onDelete2(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.imgList.splice(obj.index, 1);
        },
      });
    },
    onDelete1(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.chineseManualList.splice(obj.index, 1);
        },
      });
    },
    getBaseDetail(goodsCode) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_BASE_DATA_DETAIL,
        para: { goodsCode },
      })
        .then((res) => {
          this.basePara = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getExtendDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DETAIL,
        para: { id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          if (this.editPara.keywordList) {
            this.keywordList = this.editPara.keywordList.join(",");
          }
          let goodsTypeIdList = [];
          if (this.editPara.goodsTypeVOList && this.editPara.goodsTypeVOList.length > 0) {
            for (let i = 0; i < this.editPara.goodsTypeVOList.length; i++) {
              goodsTypeIdList.push(this.editPara.goodsTypeVOList[i].pidUrl);
            }
            this.goodsTypeIdList = goodsTypeIdList;
          }
          if (this.editPara.chineseManual) {
            this.chineseManualList.push(this.editPara.chineseManual);
          }
          if (this.editPara.goodsMaterialExtendPictureVOList && this.editPara.goodsMaterialExtendPictureVOList.length > 0) {
            for (let i = 0; i < this.editPara.goodsMaterialExtendPictureVOList.length; i++) {
              this.imgList.push(this.editPara.goodsMaterialExtendPictureVOList[i].url);
            }
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getGoodsCatList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
        para: { rank: 3, isEnabled: true },
      })
        .then((res) => {
          this.goodsCatList = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    unique(arr) {
      let map = new Map();
      let arr1 = [];
      for (let i = 0, len = arr.length; i < len; i++) {
        if (map.has(arr[i])) {
          // 判断是否存在该key值
          map.set(arr[i], true);
        } else {
          map.set(arr[i], false);
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
    getAttrList() {
      let goodsTypeIdList = [];
      for (let i = 0; i < this.goodsTypeIdList.length; i++) {
        goodsTypeIdList.push(parseInt(this.goodsTypeIdList[i].split("-")[1]), parseInt(this.goodsTypeIdList[i].split("-")[2]));
      }
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST_BY_GOODSTYPEIDS,
        para: { goodsTypeIdList: this.unique(goodsTypeIdList) },
      })
        .then((res) => {
          this.attrList = res;
          if (this.editPara.goodsAttributeVOList && this.editPara.goodsAttributeVOList.length > 0) {
            for (let i = 0; i < this.attrList.length; i++) {
              for (let j = 0; j < this.attrList[i].goodsAttributeDetailVOList.length; j++) {
                for (let k = 0; k < this.editPara.goodsAttributeVOList.length; k++) {
                  if (this.attrList[i].goodsAttributeDetailVOList[j].value == this.editPara.goodsAttributeVOList[k].values[0]) {
                    this.selectId[i] = this.attrList[i].goodsAttributeDetailVOList[j].id;
                  }
                }
              }
            }
          }
        })
        .catch(() => {});
    },
  },
  created() {
    const { id, code, edit } = this.$route.query;
    this.getGoodsCatList();
    if (code) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
        this.getExtendDetail(id);
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getBaseDetail(code);
      this.editPara.goodsCode = code;
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, code, edit } = to.query;
    this.editPara = initEditPara();
    this.goodsTypeIdList = [];
    this.chineseManualList = [];
    this.keywordList = [];
    this.imgList = [];
    this.attrList = [];
    this.selectId = "";
    this.basePara = {};
    if (code) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
        this.getExtendDetail(id);
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getBaseDetail(code);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 400px !important;
}
</style>
